import { StudioStore } from './StudioStore'

export const AlternatePlayerStore = StudioStore.named('alternatePlayer')
